module.exports = __webpack_public_path__ + "img/email_bg.e29b3670.png";